export const label = ({ theme: { colors } }) => ({
    fontSize: '12px',
    letterSpacing: '0.1px',
    color: colors.blueGrey4,
    lineHeight: 1.25,
    marginBottom: 12,
    display: 'block',
});
